import React from 'react';

import { T } from 'react-translator-component';

import { AuditEvent } from '../../../types/responses/Interoperability';
import StatusBadge from '../../atoms/StatusBadge';
import {
  counterpartLabel,
  detailLabel,
  eventLabel,
  eventMoment,
  RESULT_STYLE,
  resultLabel,
} from '../../organisms/Interoperability/AuditTab/auditLabels';
import {
  DetailCard,
  DetailHint,
  DetailMono,
  DetailRow,
  DetailTitle,
  DetailValue,
} from '../../organisms/Interoperability/styled';



export type AuditEventDrawerDetailsProps = {
  event: AuditEvent;
};

/**
 * Detalhe de um evento da trilha (MV2-1706).
 *
 * A linha da tabela é o resumo; aqui ficam o id do evento, o IP inteiro e o tipo cru
 * — o que se cola num chamado ou se compara com o log do servidor.
 *
 * Continua só leitura: a trilha não tem escrita nem remoção na API, e um painel com
 * botão de editar evento tornaria a trilha inútil como trilha.
 */
export const AuditEventDrawerDetails: React.FC<AuditEventDrawerDetailsProps> = ({ event }) => {
  const style = RESULT_STYLE[event.result];
  const detail = detailLabel(event);

  return (
    <div>
      <DetailCard>
        <DetailTitle>{T('Event')}</DetailTitle>

        <DetailRow>
          {T('Date / time')}
          <DetailValue>{eventMoment(event)}</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Event')}
          <DetailValue>{eventLabel(event)}</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Result')}
          <DetailValue>
            <StatusBadge tone={{ bg: style?.bg || '#eef0f2', fg: style?.fg || '#6b7280', dot: style?.dot || '#9aa3af' }}>
              {resultLabel(event)}
            </StatusBadge>
          </DetailValue>
        </DetailRow>

        {detail && (
          <DetailRow>
            {T('Detail')}
            <DetailValue>{detail}</DetailValue>
          </DetailRow>
        )}

        {/*
          O tipo cru aparece de proposito: e por ele que se procura no log do servidor,
          onde o rotulo traduzido nao existe.
        */}
        <DetailRow>
          {T('Type')}
          <DetailValue>
            <DetailMono>{event.event_type}</DetailMono>
          </DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Identifier')}
          <DetailValue>
            <DetailMono>{event.audit_id}</DetailMono>
          </DetailValue>
        </DetailRow>
      </DetailCard>

      <DetailCard>
        <DetailTitle>{T('Responsible')}</DetailTitle>

        <DetailRow>
          {T('Author')}
          <DetailValue>{event.actor || T('no human author')}</DetailValue>
        </DetailRow>

        <DetailRow>
          {T('IP')}
          <DetailValue>
            <DetailMono>{event.ip || '—'}</DetailMono>
          </DetailValue>
        </DetailRow>

        <DetailRow>
          {T('Partner')}
          <DetailValue>{counterpartLabel(event)}</DetailValue>
        </DetailRow>
      </DetailCard>

      <DetailCard>
        <DetailTitle>{T('Trail')}</DetailTitle>

        <DetailHint>
          {T('Read-only trail: events cannot be edited or deleted.')}
        </DetailHint>
      </DetailCard>
    </div>
  );
};
